export const BANKRUPTCY_TRUSTEE_PRODUCT_ID = '52fd73b1-97ed-4d9c-a32a-63c1fd8171c5';

export const OrderLimitationReasons = {
    Bankruptcy: 'Bankruptcy',
    BadGroupType: 'BadGroupType',
    BadStatus: 'BadStatus',
    AOProduct: 'AOProduct',
    AOCentralAgreement: 'AOCentralAgreement',
    NoMainCustomer: 'NoMainCustomer'
};

